import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from "@angular/common/http";
import { inject } from "@angular/core";
import { Observable } from "rxjs";
import { AuthService } from "../services/auth.service";
import { attachTokenToRequest } from "./interceptor.helper";

export const authenticationInterceptor: HttpInterceptorFn = (request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
    let authService = inject(AuthService)
    let token = authService.getCurrentAccessToken();
    return next(attachTokenToRequest(request, token));
}